import { DatePicker as NextDatePicker } from "@heroui/react";
import { withFormComponent } from "./hoc";

export const DatePicker = withFormComponent(NextDatePicker); 